import { connect } from 'react-redux';
import * as R from 'ramda';
import PrimaryStep3 from './PrimaryStep3';
import { getStoreValueByProp } from '../../store/sequencingWizardSlice';

const mapState = R.applySpec({
  loading: getStoreValueByProp(['locationsLoading']),
});

const mapDispatch = {};

export default connect(mapState, mapDispatch)(PrimaryStep3);
